/**
 * Created by lihanying on 2017/7/14.
 */
import React from 'react'
import { Modal, Table } from 'antd'
export default class extends React.Component {
  render() {
    const { visible, list } = this.props
    //回合消费
    const columns = [
      {
        title: 'id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '账号',
        dataIndex: 'account',
        key: 'account',
      },
      {
        title: '用户',
        dataIndex: 'nickname',
        key: 'nickname',
      },
      {
        title: '球台',
        dataIndex: 'table_name',
        key: 'table_name',
      },
      {
        title: '开始时间',
        dataIndex: 'start_time',
        key: 'start_time',
      },
      {
        title: '结束时间',
        dataIndex: 'time',
        key: 'time',
      },
      {
        title: '数量',
        dataIndex: 'num',
        key: 'num',
      },
      {
        title: '总金额',
        dataIndex: 'price',
        key: 'price',
      },
      {
        title: '单价',
        dataIndex: 'uprice',
        key: 'uprice',
      },
      {
        title: '奖金',
        dataIndex: 'profit',
        key: 'profit',
      },
    ]
    //商品消费
    const columnsCommodity = [
      {
        title: 'id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '账号',
        dataIndex: 'account',
        key: 'account',
      },
      {
        title: '用户',
        dataIndex: 'nickname',
        key: 'nickname',
      },
      {
        title: '商品名称',
        dataIndex: 'c_name',
        key: 'c_name',
      },
      {
        title: '球台',
        dataIndex: 'table_name',
        key: 'table_name',
      },
      {
        title: '购买时间',
        dataIndex: 'time',
        key: 'time',
      },
      {
        title: '数量',
        dataIndex: 'num',
        key: 'num',
      },
      {
        title: '总金额',
        dataIndex: 'price',
        key: 'price',
      },
      {
        title: '单价',
        dataIndex: 'uprice',
        key: 'uprice',
      },
    ]

    return (
      <div>
        <Modal
          title="消费详情"
          visible={visible}
          onOk={this.props.handleOk}
          onCancel={this.props.handleCancel}
          width="1000px"
        >
          <p>回合消费</p>
          <Table
            rowKey="id"
            bordered
            columns={columns}
            dataSource={list.list}
            size="middle"
          />
          <p>商品消费</p>
          <Table
            rowKey="id"
            bordered
            columns={columnsCommodity}
            dataSource={list.goodsList}
            size="middle"
          />
          <p>付款金额: ￥{list.prices}</p>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Consume/component/modalDetail.js